import {
  ItemAccessSummaryDocument,
  type ItemAccessSummaryQuery,
  RemoveAllItemMemberSharesDocument,
  RemoveAllItemTeamSharesDocument,
  SetAllItemMemberSharesDocument,
  SetAllItemTeamSharesDocument,
  SetItemVisibilityDocument,
  ShareItemDocument,
  ShareItemTeamDocument,
} from "#app/lib/data";

import { useObjectSharing } from "./use-object-sharing";

// Item flavor of useObjectSharing — same dialog contract as
// useWorkflowSharing, against the item_share table.

const MUTATIONS = {
  share: ShareItemDocument,
  shareTeam: ShareItemTeamDocument,
  removeAllMemberShares: RemoveAllItemMemberSharesDocument,
  removeAllTeamShares: RemoveAllItemTeamSharesDocument,
  setAllMemberShares: SetAllItemMemberSharesDocument,
  setAllTeamShares: SetAllItemTeamSharesDocument,
  setVisibility: SetItemVisibilityDocument,
};

const selectSummary = (data: ItemAccessSummaryQuery | undefined) =>
  data?.itemAccessSummary ?? null;

const mergePage = (
  prev: ItemAccessSummaryQuery,
  next: ItemAccessSummaryQuery,
  list: "members" | "teams",
): ItemAccessSummaryQuery => {
  const p = prev.itemAccessSummary;
  const n = next.itemAccessSummary;
  return {
    ...next,
    itemAccessSummary: {
      ...n,
      members: list === "members" ? [...p.members, ...n.members] : p.members,
      teams: list === "teams" ? [...p.teams, ...n.teams] : p.teams,
    },
  };
};

export function useItemSharing(issueId: string | null, search?: string) {
  return useObjectSharing({
    id: issueId,
    search,
    idKey: "issueId",
    summaryDocument: ItemAccessSummaryDocument,
    mutations: MUTATIONS,
    selectSummary,
    mergePage,
  });
}
